import { getDefaultThemeModeId, listThemeModes } from '../theme_modes.js';

export const DEFAULT_THEME_PACK_ID = 'core-ds1';
export const DEFAULT_THEME_REF = Object.freeze({
  packId: DEFAULT_THEME_PACK_ID,
  themeId: getDefaultThemeModeId()
});

const THEME_LIFECYCLE_OVERRIDES = Object.freeze({
  default: Object.freeze({
    lifecycle: 'active'
  }),
  dark: Object.freeze({
    lifecycle: 'active'
  }),
  pretty: Object.freeze({
    lifecycle: 'active'
  })
});

function toThemeDef(themeMode) {
  const normalized = themeMode && typeof themeMode === 'object' ? themeMode : {};
  const normalizedThemeId = String(normalized.id || getDefaultThemeModeId()).trim().toLowerCase();
  const lifecycleMeta = THEME_LIFECYCLE_OVERRIDES[normalizedThemeId] || {};
  return Object.freeze({
    themeId: normalizedThemeId,
    label: String(normalized.label || normalized.id || 'Theme'),
    tokens: normalized.tokens && typeof normalized.tokens === 'object'
      ? Object.freeze({ ...normalized.tokens })
      : Object.freeze({}),
    preview: normalized.preview && typeof normalized.preview === 'object'
      ? Object.freeze({ ...normalized.preview })
      : Object.freeze({}),
    lifecycle: String(lifecycleMeta.lifecycle || 'active').trim().toLowerCase(),
    deprecatedSince: lifecycleMeta.deprecatedSince ? String(lifecycleMeta.deprecatedSince) : undefined,
    replacementThemeRef: lifecycleMeta.replacementThemeRef || undefined,
    removedSince: lifecycleMeta.removedSince ? String(lifecycleMeta.removedSince) : undefined
  });
}

const CORE_DS1_PACK = Object.freeze({
  packId: DEFAULT_THEME_PACK_ID,
  label: 'Core DS1 Themes',
  version: 1,
  compatibleSets: Object.freeze(['ds1']),
  defaultThemeId: getDefaultThemeModeId(),
  fallbackPolicy: 'default',
  themes: Object.freeze(listThemeModes().map(toThemeDef))
});

export const THEME_PACK_REGISTRY = Object.freeze([CORE_DS1_PACK]);

export function listThemePacks() {
  return THEME_PACK_REGISTRY.slice();
}

export function getThemePackDefinition(packId = DEFAULT_THEME_PACK_ID) {
  const normalizedPackId = String(packId || '').trim().toLowerCase();
  return (
    THEME_PACK_REGISTRY.find((pack) => pack.packId === normalizedPackId)
    || THEME_PACK_REGISTRY.find((pack) => pack.packId === DEFAULT_THEME_PACK_ID)
    || null
  );
}

export function getThemeDefinition(themeId, packId = DEFAULT_THEME_PACK_ID) {
  const pack = getThemePackDefinition(packId);
  const normalizedThemeId = String(themeId || '').trim().toLowerCase();
  const fallbackThemeId = getDefaultThemeModeId();
  if (!pack) return null;
  return (
    pack.themes.find((theme) => theme.themeId === normalizedThemeId)
    || pack.themes.find((theme) => theme.themeId === fallbackThemeId)
    || null
  );
}

export function isThemeLifecycleSelectable(themeDef = {}) {
  return String(themeDef.lifecycle || 'active').trim().toLowerCase() !== 'removed';
}
